import { useQuery } from "@apollo/client";
import Download from "@mui/icons-material/Download";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { GetCohortQuery } from "generated-graphql/graphql";
import GET_DOCUMENT_DOWNLOAD_LINK_QUERY from "queries/getDocumentDownloadLink";
import { prettyPrintDateTime } from "util/dates";

type CohortDocument = NonNullable<
  NonNullable<
    NonNullable<GetCohortQuery["cohort"]>["currentWorkflow"]
  >["activities"][number]["documents"]
>[number];

export const CohortDocumentDisplay = ({ document: doc }: { document: CohortDocument }) => {
  const { data } = useQuery(GET_DOCUMENT_DOWNLOAD_LINK_QUERY, {
    variables: { id: doc.document.id },
  });

  const downloadLink = data?.getDocumentDownloadLink;
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      key={doc.document.id}
      sx={{ p: 2, bgcolor: "grey.50", borderRadius: 1 }}
    >
      <Box width="100%">
        <Typography variant="body2" fontWeight="medium">
          {doc.document.title}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Updated: {prettyPrintDateTime(doc.document.updatedAt)}
          {doc.document.sizeMegabytes && ` | Size: ${doc.document.sizeMegabytes.toFixed(2)} MB`}
        </Typography>
        {doc.document.description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {doc.document.description}
          </Typography>
        )}
      </Box>
      {downloadLink && (
        <IconButton size="small" onClick={() => window.open(downloadLink, "_blank")}>
          <Download />
        </IconButton>
      )}
    </Stack>
  );
};
